<template>
    <div class="row">
        <div class="col-12">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <li :class="fxsymbolprice == 1 ? 'active' : ''" v-on:click.prevent="fxsymbolprice = 1"
                    v-if="checkROll('deposits')"><a href="#">{{ $t('acc_fund_Deposit') }}</a></li>
                <li :class="fxsymbolprice == 2 ? 'active' : ''" v-on:click.prevent="fxsymbolprice = 2"
                    v-if="checkROll('withdrawals')"><a href="#">{{ $t('acc_fund_Withdrawal') }}</a></li>
            </ul>
        </div>
        <div class="col-12" v-if="fxsymbolprice == 1 && checkROll('deposits')">
            <app-deposit></app-deposit>
            <app-deposit-list></app-deposit-list>
        </div>
        <div class="col-12" v-else-if="fxsymbolprice == 2 && checkROll('withdrawals')">
            <app-withdrawal></app-withdrawal>
            <app-withdrawal-list></app-withdrawal-list>
        </div>
    </div>
</template>
<script>
import withdrawal from '../withdrawal/withdrawal'
import deposit from '../deposit/deposit'
import deposit_listing from '../deposit/deposit_listing'
import withdrawal_listing from '../withdrawal/withdrawal_listing'
export default {
    name: 'Wallet',
    data() {
        return {
            response_msg: '',
            msg_type: '',
            pageLoader: false,
            fxsymbolprice: 1,
        }
    },
    components: {
        appWithdrawal: withdrawal,
        appDeposit: deposit,
        appDepositList: deposit_listing,
        appWithdrawalList: withdrawal_listing
    },
    created() {
        if (this.checkROll('deposits')) {
            this.fxsymbolprice = 1
        } else if (this.checkROll('withdrawals')) {
            this.fxsymbolprice = 2
        } else {
            this.$router.replace('/dashboard')
        }
        if (this.$route.params.page && this.$route.params.page == 'deposit') {
            this.fxsymbolprice = '1'
            // this.$router.replace({})
        }
        else if (this.$route.params.page && this.$route.params.page == 'withdrawal') {
            this.fxsymbolprice = '2'
            // this.$router.replace({})
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/account-funding.vue